import { Component, h, Listen, Prop, State } from '@stencil/core';

@Component({
  tag: 'rzf-back-to-top',
  styleUrl: 'rzf-back-to-top.css',
  shadow: true,
})
export class RzfBackToTop {
  @State() isVisible: boolean = false;
  @Prop() targetSelector: string;

  targetElement: HTMLElement;

  componentWillLoad() {
    this.targetElement = document.querySelector(this.targetSelector);
    this.toggleButton();
  }

  @Listen('scroll', { target: 'window', passive: true })
  handleScroll() {
    if (this.targetElement) {
      this.toggleButton();
    }
  }

  toggleButton() {
    const targetPosition = this.targetElement.getBoundingClientRect().top + window.scrollY;
    if (window.scrollY > targetPosition) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  render() {
    return (
      <button class={{ 'back-to-top': true, 'back-to-top--visible': this.isVisible }} onClick={() => this.scrollToTop()} aria-label="Back to top">
        <slot></slot>
      </button>
    );
  }
}
